import React, { ReactNode, useState } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { fetchApi, serverURL, siteURL } from "./Funciones";

interface AuthContextType {
	user: any;
	login: (username: string, password: string, token: string, callback: Function) => void;
	logout: (callback: VoidFunction) => void;
}
let AuthContext = React.createContext<AuthContextType>(null!);

export const useAuth = () => {
	return React.useContext(AuthContext);
}
export const AuthProvider = ({ children }: { children: React.ReactNode }) => {
	let [user, setUser] = useState<any>(null);

	let login = async (username: string, password: string, token: string, callback: Function) => {
		let resp;
		if (token !== "") {
			resp = await fetchApi("", "auth", { cmd: "login", token: token })
		}
		if (username !== "" && password !== "") {
			resp = await fetchApi("", "auth", { cmd: "login", user: username, pass: password })
		}
		if (resp && resp.estado === "ok") {
			localStorage.setItem("token", resp.user.token)
			setUser(resp.user)
			callback(resp.user !== null)
		}
		else {
			callback(false)
		}
	}

	let logout = (callback: VoidFunction) => {
		setUser(null);
		localStorage.clear()
		if (callback)
			callback();
	}
	let value = { user, login, logout }

	return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const RequireAuth = ({ children }: { children: JSX.Element }) => {
	let auth = useAuth();
	let location = useLocation();
	if (!auth.user) {
		//return <Navigate to="/login" state={{ from: location }} replace />
		//return <Navigate to={serverURL} state={{ from: location }} replace />
		return <Navigate to={siteURL} state={{ from: location }} replace />
	}
	return children;
}

export const TienePermiso: React.FC<{ children: ReactNode, permisos: Array<number> }> = ({ children, permisos }) => {
	let auth = useAuth();
	if (auth.user) {
		let tiene = auth.user.permisos as Array<string>;
		var found = false;
		for (var i = 0; i < permisos.length; i++) {
			if (tiene.indexOf(permisos[i] + "") !== -1) {
				found = true;
				break;
			}
		}
		if (!found) {
			return <></>;
		}
		else {
			return <>{children}</>;
		}
	}
	else {
		return <></>
	}
};
export const TieneRol: React.FC<{ children: ReactNode, roles: Array<number> }> = ({ children, roles }) => {
	let auth = useAuth();
	if (auth.user) {
		let tiene = auth.user.roles as Array<string>;
		var found = false;
		for (var i = 0; i < roles.length; i++) {
			if (tiene.indexOf(roles[i] + "") !== -1) {
				found = true;
				break;
			}
		}
		if (!found) {
			return <></>;
		}
		else {
			return <>{children}</>;
		}
	}
	else {
		return <></>
	}
};